import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

import TopStories from "dashboard/components/TopStories";
import { getStoriesStream } from "actions/storiesStream";
import { setSectionWithTag, setSection } from "actions/navigation";
import { FRONTEND_ROOT } from "config/constants";

class TagStream extends React.Component {
  constructor(props) {
    super(props);

    this.loadNextPage = this._loadNextPage.bind(this);
  }

  componentDidMount() {
    this.loadStream(this.props);
  }

  componentWillUnmount() {
    this.props.setSection(null);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.tag !== nextProps.match.params.tag) {
      this.loadStream(nextProps);
    }
  }

  loadStream(props) {
    this.props.setSectionWithTag(props.match.params.tag);
    this.props.getStoriesStream({ stream: props.match.params.tag });
  }

  _loadNextPage(page) {
    return this.props.getStoriesStream({
      page,
      stream: this.props.match.params.tag,
    }, true);
  }

  render() {
    return (
      <div>
        {this.props.section && (
          <Helmet>
            <title>{this.props.section.name} - Axios</title>
            <meta property="og:url" content={`${FRONTEND_ROOT}/tag/${this.props.section.slug}/`} />
            <meta property="og:title" content={`${this.props.section.name} on Axios`} />
          </Helmet>
        )}
        <TopStories
          isTagPage
          loadNextPage={this.loadNextPage}
        />
      </div>
    );
  }
}

TagStream.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      tag: PropTypes.string.isRequired,
    }),
  }),
  section: PropTypes.object,
  setSectionWithTag: PropTypes.func.isRequired,
  getStoriesStream: PropTypes.func.isRequired,
  setSection: PropTypes.func,
};

const mapStateToProps = (state) => ({
  section: state.navigation.data.section,
});

const mapDispatchToProps = {
  setSectionWithTag,
  getStoriesStream,
  setSection,
};

export default connect(mapStateToProps, mapDispatchToProps)(TagStream);



// WEBPACK FOOTER //
// ./src/dashboard/containers/TagStream/TagStream.js